import React, { useState } from "react";
import {
    CheckCircle2,
    AlertTriangle,
    Star,
    TrendingUp,
    CalendarDays,
    ChevronDown,
} from "lucide-react";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import "../PerformanceStyles.css";

/* ── Static demo data ── */
const kpiCards = [
    {
        label: "Entretiens Complétés",
        value: "7",
        hint: "Validés et signés",
        icon: CheckCircle2,
        iconBg: "#e8edf7",
        iconColor: "#2f4595",
        valueColor: "#2f4595",
    },
    {
        label: "Entretiens En Retard",
        value: "3",
        hint: "Dépassement deadline",
        icon: AlertTriangle,
        iconBg: "#fff1f2",
        iconColor: "#2f4595",
        valueColor: "#ef4444",
    },
    {
        label: "Performance Équipe",
        value: "82%",
        hint: "Moyenne des évaluations",
        icon: Star,
        iconBg: "#fef9c3",
        iconColor: "#455584",
        valueColor: "#2f4595",
    },
    {
        label: "Objectifs Équipe",
        value: "75%",
        hint: "Taux de réalisation global",
        icon: TrendingUp,
        iconBg: "#e8edf7",
        iconColor: "#2f4595",
        valueColor: "#2f4595",
    },
];

/* Chart data – Suivi des Entretiens */
const chartData = [
    { month: "Jan", Terminés: 50, "En cours": 30, Planifiés: 120 },
    { month: "Fév", Terminés: 100, "En cours": 80, Planifiés: 200 },
    { month: "Mar", Terminés: 180, "En cours": 150, Planifiés: 320 },
    { month: "Avr", Terminés: 260, "En cours": 220, Planifiés: 440 },
    { month: "Mai", Terminés: 340, "En cours": 280, Planifiés: 560 },
    { month: "Jun", Terminés: 400, "En cours": 330, Planifiés: 680 },
    { month: "Jul", Terminés: 480, "En cours": 360, Planifiés: 780 },
    { month: "Aoû", Terminés: 550, "En cours": 380, Planifiés: 880 },
    { month: "Sep", Terminés: 620, "En cours": 400, Planifiés: 960 },
    { month: "Oct", Terminés: 720, "En cours": 420, Planifiés: 1050 },
    { month: "Nov", Terminés: 850, "En cours": 450, Planifiés: 1150 },
    { month: "Déc", Terminés: 1000, "En cours": 480, Planifiés: 1300 },
];

const tabs = ["Progression", "Objectifs", "Compétences"];

export default function TDBmanager() {
    const [campagne, setCampagne] = useState("campagne de performance");
    const [dateDebut, setDateDebut] = useState("");
    const [dateFin, setDateFin] = useState("");
    const [activeTab, setActiveTab] = useState("Progression");

    return (
        <div className="tdb-mgr-page">
            <style>{tdbManagerStyles}</style>

            {/* ── Page title ── */}
            <h1 className="tdb-m-page-title">Tableau de bord</h1>

            {/* ── Filters bar ── */}
            <section className="tdb-m-filters">
                <div className="tdb-m-filter-group">
                    <label className="tdb-m-filter-label">Campagne</label>
                    <div className="tdb-m-select-wrap">
                        <select
                            className="tdb-m-select"
                            value={campagne}
                            onChange={(e) => setCampagne(e.target.value)}
                        >
                            <option>campagne de performance</option>
                        </select>
                        <ChevronDown size={16} className="tdb-m-select-icon" />
                    </div>
                </div>

                <div className="tdb-m-filter-group tdb-m-filter-date">
                    <label className="tdb-m-filter-label">Date de début</label>
                    <div className="tdb-m-date-wrap">
                        <input
                            type="date"
                            className="tdb-m-date-input"
                            value={dateDebut}
                            onChange={(e) => setDateDebut(e.target.value)}
                            placeholder="jj/mm/aaaa"
                        />
                        <CalendarDays size={16} className="tdb-m-date-icon" />
                    </div>
                </div>

                <div className="tdb-m-filter-group tdb-m-filter-date">
                    <label className="tdb-m-filter-label">Date de fin</label>
                    <div className="tdb-m-date-wrap">
                        <input
                            type="date"
                            className="tdb-m-date-input"
                            value={dateFin}
                            onChange={(e) => setDateFin(e.target.value)}
                            placeholder="jj/mm/aaaa"
                        />
                        <CalendarDays size={16} className="tdb-m-date-icon" />
                    </div>
                </div>
            </section>

            {/* ── KPI cards ── */}
            <section className="tdb-m-kpi-grid">
                {kpiCards.map((kpi) => {
                    const Icon = kpi.icon;
                    return (
                        <article className="tdb-m-kpi-card" key={kpi.label}>
                            <div className="tdb-m-kpi-top">
                                <span
                                    className="tdb-m-kpi-icon"
                                    style={{ background: kpi.iconBg, color: kpi.iconColor }}
                                >
                                    <Icon size={22} />
                                </span>
                                <div className="tdb-m-kpi-info">
                                    <span className="tdb-m-kpi-label">{kpi.label}</span>
                                </div>
                            </div>
                            <div className="tdb-m-kpi-bottom">
                                <span
                                    className="tdb-m-kpi-value"
                                    style={{ color: kpi.valueColor }}
                                >
                                    {kpi.value}
                                </span>
                                <span className="tdb-m-kpi-hint">{kpi.hint}</span>
                            </div>
                        </article>
                    );
                })}
            </section>

            {/* ── Tabs ── */}
            <section className="tdb-m-tabs-section">
                <div className="tdb-m-tabs">
                    {tabs.map((tab) => (
                        <button
                            key={tab}
                            className={`tdb-m-tab ${activeTab === tab ? "tdb-m-tab--active" : ""}`}
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab}
                        </button>
                    ))}
                </div>

                {/* ── Tab content ── */}
                <div className="tdb-m-tab-content">
                    {activeTab === "Progression" && (
                        <div className="tdb-m-chart-section">
                            <h2 className="tdb-m-chart-title">Suivi des Entretiens</h2>
                            <div className="tdb-m-chart-container">
                                <ResponsiveContainer width="100%" height={380}>
                                    <LineChart data={chartData} margin={{ top: 10, right: 30, left: 10, bottom: 10 }}>
                                        <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" />
                                        <XAxis
                                            dataKey="month"
                                            tick={{ fontSize: 12, fill: "#6b7280" }}
                                            axisLine={{ stroke: "#e5e7eb" }}
                                            tickLine={false}
                                        />
                                        <YAxis
                                            tick={{ fontSize: 12, fill: "#6b7280" }}
                                            axisLine={{ stroke: "#e5e7eb" }}
                                            tickLine={false}
                                            tickFormatter={(v) => `${v}`}
                                            label={{
                                                value: "Nbre collab",
                                                angle: -90,
                                                position: "insideLeft",
                                                offset: 0,
                                                style: { fontSize: 11, fill: "#9ca3af", fontWeight: 600 },
                                            }}
                                        />
                                        <Tooltip
                                            contentStyle={{
                                                background: "#fff",
                                                border: "1px solid #e5e7eb",
                                                borderRadius: "10px",
                                                boxShadow: "0 4px 16px rgba(32,67,133,.1)",
                                                fontSize: 13,
                                            }}
                                        />
                                        <Legend
                                            verticalAlign="top"
                                            align="center"
                                            iconType="square"
                                            wrapperStyle={{
                                                paddingBottom: 16,
                                                fontSize: 13,
                                                fontWeight: 600,
                                            }}
                                        />
                                        <Line
                                            type="monotone"
                                            dataKey="Terminés"
                                            stroke="#16a34a"
                                            strokeWidth={2.5}
                                            dot={{ r: 3, fill: "#16a34a" }}
                                            activeDot={{ r: 5, stroke: "#fff", strokeWidth: 2 }}
                                        />
                                        <Line
                                            type="monotone"
                                            dataKey="En cours"
                                            stroke="#2f4595"
                                            strokeWidth={2.5}
                                            dot={{ r: 3, fill: "#2f4595" }}
                                            activeDot={{ r: 5, stroke: "#fff", strokeWidth: 2 }}
                                        />
                                        <Line
                                            type="monotone"
                                            dataKey="Planifiés"
                                            stroke="#2f478f"
                                            strokeWidth={2.5}
                                            dot={{ r: 3, fill: "#2f478f" }}
                                            activeDot={{ r: 5, stroke: "#fff", strokeWidth: 2 }}
                                        />
                                    </LineChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    )}

                    {activeTab === "Objectifs" && (
                        <div className="tdb-m-placeholder-tab">
                            <div className="tdb-m-placeholder-icon">🎯</div>
                            <h3>Suivi des Objectifs</h3>
                            <p>Détails des objectifs de l'équipe à venir.</p>
                        </div>
                    )}

                    {activeTab === "Compétences" && (
                        <div className="tdb-m-placeholder-tab">
                            <div className="tdb-m-placeholder-icon">📊</div>
                            <h3>Analyse des Compétences</h3>
                            <p>Synthèse des compétences de l'équipe à venir.</p>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
}

/* ── Scoped styles ── */
const tdbManagerStyles = `
.tdb-mgr-page {
    padding: 28px 32px;
    background: #f7f9fc;
    min-height: 100vh;
    font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
    color: #111827;
}

/* ── Page title ── */
.tdb-m-page-title {
    margin: 0 0 22px;
    font-size: 24px;
    font-weight: 800;
    color: #2f4595;
    letter-spacing: -.01em;
}

/* ── Filters ── */
.tdb-m-filters {
    display: flex;
    align-items: flex-end;
    gap: 20px;
    padding: 22px 28px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    box-shadow: 0 2px 12px rgba(32,67,133,.05);
    margin-bottom: 24px;
    flex-wrap: wrap;
}

.tdb-m-filter-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1;
    min-width: 180px;
}

.tdb-m-filter-group:first-child {
    flex: 2;
}

.tdb-m-filter-date {
    flex: 1;
    max-width: 220px;
}

.tdb-m-filter-label {
    font-size: 12px;
    font-weight: 700;
    color: #2f4595;
    letter-spacing: .02em;
}

.tdb-m-select-wrap {
    position: relative;
}

.tdb-m-select {
    width: 100%;
    appearance: none;
    border: 1.5px solid #e5e7eb;
    border-radius: 10px;
    padding: 10px 36px 10px 14px;
    font-size: 13px;
    color: #374151;
    background: #fff;
    font-family: inherit;
    cursor: pointer;
    outline: none;
    transition: border-color .2s, box-shadow .2s;
}

.tdb-m-select:focus {
    border-color: #2f4595;
    box-shadow: 0 0 0 3px rgba(32,67,133,.1);
}

.tdb-m-select-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
    pointer-events: none;
}

.tdb-m-date-wrap {
    position: relative;
}

.tdb-m-date-input {
    width: 100%;
    border: 1.5px solid #e5e7eb;
    border-radius: 10px;
    padding: 10px 14px;
    font-size: 13px;
    color: #374151;
    background: #fff;
    font-family: inherit;
    outline: none;
    transition: border-color .2s, box-shadow .2s;
    box-sizing: border-box;
}

.tdb-m-date-input:focus {
    border-color: #2f4595;
    box-shadow: 0 0 0 3px rgba(32,67,133,.1);
}

.tdb-m-date-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
    pointer-events: none;
}

/* ── KPI cards grid (4 columns for manager) ── */
.tdb-m-kpi-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
    margin-bottom: 28px;
}

.tdb-m-kpi-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    padding: 22px 24px;
    box-shadow: 0 2px 12px rgba(32,67,133,.05);
    display: flex;
    flex-direction: column;
    gap: 14px;
    transition: box-shadow .2s, transform .2s;
}

.tdb-m-kpi-card:hover {
    box-shadow: 0 6px 24px rgba(32,67,133,.1);
    transform: translateY(-2px);
}

.tdb-m-kpi-top {
    display: flex;
    align-items: center;
    gap: 14px;
}

.tdb-m-kpi-icon {
    width: 46px;
    height: 46px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.tdb-m-kpi-info {
    flex: 1;
}

.tdb-m-kpi-label {
    font-size: 13px;
    font-weight: 600;
    color: #6b7280;
}

.tdb-m-kpi-bottom {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.tdb-m-kpi-value {
    font-size: 32px;
    font-weight: 900;
    line-height: 1.1;
    letter-spacing: -.02em;
}

.tdb-m-kpi-hint {
    font-size: 12px;
    color: #9ca3af;
    font-weight: 500;
}

/* ── Tabs section ── */
.tdb-m-tabs-section {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    box-shadow: 0 2px 12px rgba(32,67,133,.05);
    overflow: hidden;
}

.tdb-m-tabs {
    display: flex;
    gap: 0;
    border-bottom: 2px solid #eef2f7;
    padding: 0 28px;
}

.tdb-m-tab {
    background: none;
    border: none;
    padding: 16px 20px;
    font-size: 14px;
    font-weight: 600;
    color: #6b7280;
    cursor: pointer;
    font-family: inherit;
    position: relative;
    transition: color .2s;
    white-space: nowrap;
}

.tdb-m-tab:hover {
    color: #2f4595;
}

.tdb-m-tab--active {
    color: #2f4595;
    font-weight: 700;
}

.tdb-m-tab--active::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -2px;
    height: 3px;
    background: #2f4595;
    border-radius: 3px 3px 0 0;
}

/* ── Tab content ── */
.tdb-m-tab-content {
    padding: 28px;
}

/* ── Chart section ── */
.tdb-m-chart-section {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.tdb-m-chart-title {
    margin: 0;
    font-size: 17px;
    font-weight: 800;
    color: #2f4595;
}

.tdb-m-chart-container {
    width: 100%;
    min-height: 380px;
}

/* ── Placeholder tab ── */
.tdb-m-placeholder-tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 280px;
    gap: 12px;
    text-align: center;
}

.tdb-m-placeholder-icon {
    font-size: 42px;
    margin-bottom: 4px;
}

.tdb-m-placeholder-tab h3 {
    margin: 0;
    font-size: 17px;
    font-weight: 700;
    color: #2f4595;
}

.tdb-m-placeholder-tab p {
    margin: 0;
    font-size: 13px;
    color: #9ca3af;
    font-weight: 500;
}

/* ── Responsive ── */
@media (max-width: 1100px) {
    .tdb-m-kpi-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .tdb-mgr-page {
        padding: 16px;
    }

    .tdb-m-filters {
        flex-direction: column;
        align-items: stretch;
    }

    .tdb-m-filter-group:first-child,
    .tdb-m-filter-date {
        flex: 1;
        max-width: none;
    }

    .tdb-m-kpi-grid {
        grid-template-columns: 1fr;
    }

    .tdb-m-tabs {
        overflow-x: auto;
        padding: 0 16px;
    }

    .tdb-m-tab-content {
        padding: 16px;
    }
}
`;
